import React from 'react';
import { GlobalStyles } from '@mui/material';

export default (
    <GlobalStyles
        styles={`
      /* Import Inter font from Google Fonts with preconnect for better performance */
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');
      
      
      /* Define font-face for Inter Regular specifically to fix loading issues */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('https://fonts.gstatic.com/s/inter/v13/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZ9hiJ-Ek-_EeA.woff2') format('woff2');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
      }
      
      /* Fallback system fonts if Inter fails to load */
      body {
        font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        font-feature-settings: 'cv02', 'cv03', 'cv04', 'cv11';
      }
      
      /* Ensure all elements inherit the font */
      * {
        font-family: inherit;
      }
      
      /* Custom utility classes for consistent font weights */
      .font-inter-thin { font-family: 'Inter', system-ui, sans-serif; font-weight: 100; }
      .font-inter-extralight { font-family: 'Inter', system-ui, sans-serif; font-weight: 200; }
      .font-inter-light { font-family: 'Inter', system-ui, sans-serif; font-weight: 300; }
      .font-inter-regular { font-family: 'Inter', system-ui, sans-serif; font-weight: 400; }
      .font-inter-medium { font-family: 'Inter', system-ui, sans-serif; font-weight: 500; }
      .font-inter-semibold { font-family: 'Inter', system-ui, sans-serif; font-weight: 600; }
      .font-inter-bold { font-family: 'Inter', system-ui, sans-serif; font-weight: 700; }
      .font-inter-extrabold { font-family: 'Inter', system-ui, sans-serif; font-weight: 800; }
      .font-inter-black { font-family: 'Inter', system-ui, sans-serif; font-weight: 900; }
    `}
    />
);
